

import React, { useEffect, useState } from 'react';
import { Table, Input, Row, Col, Select, Button, Popconfirm, Space } from 'antd';
import AppLayout from '../../components/AppLayout';

const DowntimeEntries: React.FC = () => {
  const [entries, setEntries] = useState<any[]>([]);
  const [filteredEntries, setFilteredEntries] = useState<any[]>([]);
  const [filters, setFilters] = useState({ equipment: '', reason: '' });

  useEffect(() => {
    const demoData = Array.from({ length: 5 }, (_, i) => ({
      id: i + 1,
      equipment: `Machine ${i + 1}`,
      reason: ['Maintenance', 'Power Failure', 'Operator Error', 'Mechanical Issue', 'Inspection'][i],
      duration: `${Math.floor(Math.random() * 3) + 1}h`,
      technician: `Technician ${i + 1}`,
      date: `2024-07-${(i + 1).toString().padStart(2, '0')}`,
    }));
    setEntries(demoData);
    setFilteredEntries(demoData);
  }, []);

  const handleFilterChange = (field: string, value: string) => {
    const updated = { ...filters, [field]: value };
    setFilters(updated);
    const result = entries.filter(e =>
      (updated.equipment === '' || e.equipment.toLowerCase().includes(updated.equipment.toLowerCase())) &&
      (updated.reason === '' || e.reason === updated.reason)
    );
    setFilteredEntries(result);
  };

  const columns = [
    { title: 'Equipment', dataIndex: 'equipment', key: 'equipment' },
    { title: 'Reason', dataIndex: 'reason', key: 'reason' },
    { title: 'Duration', dataIndex: 'duration', key: 'duration' },
    { title: 'Technician', dataIndex: 'technician', key: 'technician' },
    { title: 'Date', dataIndex: 'date', key: 'date' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: any) => (
        <Space>
          <Button type="link">Edit</Button>
          <Popconfirm title="Are you sure to delete?" onConfirm={() => console.log('Delete', record.id)}>
            <Button danger type="link">Delete</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <AppLayout>
      <h3>Downtime Entries</h3>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={12}>
          <Input
            placeholder="Search Equipment"
            value={filters.equipment}
            onChange={(e) => handleFilterChange('equipment', e.target.value)}
          />
        </Col>
        <Col span={12}>
          <Select
            placeholder="Filter by Reason"
            value={filters.reason}
            onChange={(val) => handleFilterChange('reason', val)}
            allowClear
            style={{ width: '100%' }}
          >
            <Select.Option value="Maintenance">Maintenance</Select.Option>
            <Select.Option value="Power Failure">Power Failure</Select.Option>
            <Select.Option value="Operator Error">Operator Error</Select.Option>
            <Select.Option value="Mechanical Issue">Mechanical Issue</Select.Option>
            <Select.Option value="Inspection">Inspection</Select.Option>
          </Select>
        </Col>
      </Row>
      <Table
        dataSource={filteredEntries}
        columns={columns}
        rowKey="id"
        pagination={{ pageSize: 5 }}
      />
    </AppLayout>
  );
};

export default DowntimeEntries;